import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
const CONSENT_KEY = "cookie_consent";
const getStoredConsent = () => {
    return localStorage.getItem(CONSENT_KEY);
};
const updateGtagConsent = (value) => {
    if (window.gtag) {
        window.gtag("consent", "update", {
            analytics_storage: value,
        });
    }
};
const CookieConsent = () => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const stored = getStoredConsent();
        if (stored === null) {
            setVisible(true);
        }
        else if (stored === "granted") {
            updateGtagConsent("granted");
        }
    }, []);
    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, "granted");
        updateGtagConsent("granted");
        setVisible(false);
    };
    const handleDecline = () => {
        localStorage.setItem(CONSENT_KEY, "denied");
        updateGtagConsent("denied");
        setVisible(false);
    };
    if (!visible) {
        return null;
    }
    return (_jsxs(Paper, { elevation: 6, role: "dialog", "aria-label": "Cookie consent", sx: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1400,
            p: { xs: 2, sm: 3 },
            borderRadius: 0,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
        }, children: [_jsx(Typography, { variant: "body2", sx: { flex: 1 }, children: "We use cookies to understand how you use our site and improve your experience. You can accept or decline analytics cookies." }), _jsxs(Box, { sx: {
                    display: "flex",
                    gap: 1,
                    flexShrink: 0,
                }, children: [_jsx(Button, { variant: "outlined", size: "small", onClick: handleDecline, children: "Decline" }), _jsx(Button, { variant: "contained", size: "small", onClick: handleAccept, children: "Accept" })] })] }));
};
export default CookieConsent;
